const getInnerPath = (fullPath: string) => fullPath.split('/').slice(4).join('/');
export default getInnerPath;
